<script setup lang="ts">
    import { useRoute } from 'vue-router';
    import { computed, inject, onMounted, reactive, ref, toRaw } from 'vue';
    import axios from 'axios';
    import moment from 'moment';
    import { formatDateFrench } from '@/utils';
    import UserWalletUtilisation from './@components/UserWalletUtilisation.vue';
    import UserTransactions from './@components/UserTransactions.vue';

    const BACKEND_URL = inject('BACKEND_URL');
    const route = useRoute();
    const startupinfos: any = route.meta.startup_datas;
    const user: any = startupinfos.user;

    const quotiteUsedPercent = computed(() => {
        if (!user || !user.quotite_cessible_montant || !user.salaire || user.salaire <= 0) return 0;
        // Si on a une utilisation, on peut la calculer, sinon 0
        // Pour l'instant, on retourne 0 car on n'a pas de données d'utilisation
        return 0;
    });
</script>
<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-40"></div>

        <h4 class="s7 font-semibold px-3 pb-5">Membre / Utilisation <span class="text-sm text-grey-500"></span></h4>
        <div class="s13 flex-right gap-3 mt--2 mb-5 px-5">
            <span class="btn shadow-200 white2">Wallet / Utilisation</span>
            <span class="btn shadow-200 light2 border-none">Transactions</span>
        </div>

        <!--User info - Component-->
        <div class="s20 widget flex align-items-center px-1 py-5">
            <div class="s2_mobile h-100p px-7">
                <div class="rounded-100 overflow-hidden item active"><!--active-->
                    <img :src="!!user.photo_url ? user.photo_url : '/assets/users_avatar/600w/user.jpg'" width="100%" />
                </div>
            </div>
            <div class="s4_mobile h-100p px-2">
                <h4 class="text-grey-900 mb-3" v-if="user.kyc?.id">n° CF{{ user.created_at ? moment(user.created_at).format('YYYY') : '2025' }}-{{ String(user.kyc.id).padStart(6, '0') }}</h4>
                <h4 class="text-grey-900 mb-3" v-else>n° -</h4>
                <h4>{{ user.nom + ' ' + user.prenom }}</h4>
            </div>
            <div class="s3_mobile h-100p px-2">
                <h4 class="font-normal mb-5">{{ user.collectivite?.nom }}</h4>
                <span class="tag-state warning stroke">En cours</span>
                <span class="tag-state notif stroke">Actif</span>
            </div>
            <div class="s4_mobile h-100p px-3">
                <h4 class="font-normal">
                    Date de fin de souscription <br class="mb-2"/>
                    <b class="text-2xl">{{ user.souscription ? formatDateFrench(user.souscription.date_fin) : '-' }}</b>
                </h4>
            </div>
            <div class="s7_mobile h-100p px-5">
                <!--Barre de progression - Component-->
                <div class="h-60 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                    <div class="widget-floating py-0 text-xl flex-right">Utilisation</div>
                    <div class="h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green" :style="{'width': quotiteUsedPercent + '%'}">
                        {{ quotiteUsedPercent }}%
                    </div>
                </div>
                <!--End Barre de progression-->
            </div>
        </div>
        <!--End User info-->

        <div class="clear-both h-20"></div>


        <!--Transactions - Component-->
        <user-wallet-utilisation :user-id="user.id" />

        <div class="clear-both h-5"></div>
        <div class="step vertical bg-grey-500 ml-auto mr-auto"></div>
        <div class="clear-both h-5"></div>


        <user-transactions :user-id="user.id" />


        <div class="clear-both h-80"></div>

    </section>
</template>